import { PdpReviewForm } from 'features/review-form/review-form-connected';
import React from 'react';
import { Breakpoint } from 'types/utils';
import {
  LARGE_DESK_SCREEN,
  MEDIUM_DESK_SCREEN,
  TABLET_SCREEN,
  MOBILE_SCREEN,
} from 'utils/internal-specifics/media-queries';
import { addMediaQueryHandlers } from 'utils/add-media-query-handlers';

export const ReviewsFormContent: React.FC = () => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>('large');

  React.useEffect(
    () =>
      addMediaQueryHandlers(
        [LARGE_DESK_SCREEN, MEDIUM_DESK_SCREEN, TABLET_SCREEN, MOBILE_SCREEN],
        ['large', 'medium', 'tablet', 'mobile'],
        'large',
        setBreakpoint,
      ),
    [],
  );

  return (
    <>
      <PdpReviewForm breakpoint={breakpoint} />
    </>
  );
};
